import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/models/interfaces/order';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { AdminOrdersService } from '../../services/orders/admin-orders.service';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OrderState } from '../../state/order.state';
import { GetOrderMsg } from '../../state/order-action';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-client-notes',
    templateUrl: './client-notes.component.html',
    styleUrls: ['./client-notes.component.scss'],
    standalone: false
})
export class ClientNotesComponent implements OnInit {
  orderId: string;

  public orders: Order;
  headerTxt: string = 'إرسال تنبيه';
  deleteMsg: string = 'هل أنت متأكد من حذف هذا الرسالة؟';
  messagePk: number;
  messages: any[] = [];
  messageIndex: any;
  @Input() inspector_status;
  child: string = 'ClientNotesComponent';
  @Input() reciver_status;
  confirmBtn: string = 'حذف';
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  orderMsg$: Observable<any>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private adminOrdersService: AdminOrdersService,
    private store: Store,
    private sanitizer: DomSanitizer
  ) {
    this.orderMsg$ = this.store.select(OrderState.getOrderMsg);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.orderId = params['id'];
      this.store.dispatch(new GetOrderMsg({ orderId: +this.orderId }));
      this.getMessagesLog(this.orderId);
    });
  }

  getMessagesLog(orderID) {
    this.orderMsg$.subscribe((data) => {
      this.messages = data;

    });
  }

  deleteMessage(messagePk, index) {
    this.messagePk = messagePk;
    this.messageIndex = index;
    this.showDeleteConfirmationBox();
  }

  showDeleteConfirmationBox() {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id: this.messagePk,
        index: this.messageIndex,
        message: this.deleteMsg,
        confirmBtn: this.confirmBtn,
        isDelete: true,
      },
    });
    this.deleteDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.doAction(result);
      }
    });
  }

  doAction(event) {
    let id = event.id;
    let index = event.index;
    this.adminOrdersService.deleteMessage(id).subscribe(
      (data) => {
        this.messages.splice(index, 1);
      },
      (error) => {
        this.handleBackendError(error);
      }
    );
  }

  handleBackendError(error) {
    try {
      console.log(error);
    } catch {
      console.log(error);
    }
  }

  sanitize(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }
}
